import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button/index';
import './Summary.css';

const Summary = ({ handleGoToDashboard }) => (
  <div className="summary-card">
    <div className="summary-card__header">
      <Button
        className="summary-card__header-button"
        rounded
        title="VIEW MY DASHBOARD"
        onClick={handleGoToDashboard}
      />
    </div>
    <div className="summary-card__image" />
  </div>
);

Summary.propTypes = {
  handleGoToDashboard: PropTypes.func,
};

export default Summary;



// WEBPACK FOOTER //
// ./src/components/Summary/Summary.js